import { IInfoTeamPlayers } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";

export interface GroupFactsParams {
  group_id: number;
}

export const GetGroupFacts = async ({ group_id: grid }: GroupFactsParams): Promise<IInfoTeamPlayers | null> => {
  const groupFacts = withErrorCheck(
    // @ts-ignore
    await server.rpc("group_facts", { grid })
  );

  if (!groupFacts) return null;

  return groupFacts;
};
